import secureLocalStorage from "react-secure-storage";
import { stdObject } from "../../../data/types/stdObject";

export const getBranchInfo = (data: stdObject) => {
  let branchData: any = secureLocalStorage.getItem("branch");
  if (typeof branchData === "string") {
    try {
      branchData = JSON.parse(branchData);
      Object.keys(branchData).forEach((e: string) => {
        if (e in data) {
          data[e] = branchData[e];
        }
      });
    } catch (error) {
      console.log("branchData error: ", branchData);
    }
  }
  return data;
};
